import { render, staticRenderFns } from "./PeopleSliderReview.vue?vue&type=template&id=c34f1614&scoped=true&"
import script from "./PeopleSliderReview.vue?vue&type=script&lang=js&"
export * from "./PeopleSliderReview.vue?vue&type=script&lang=js&"
import style0 from "./PeopleSliderReview.vue?vue&type=style&index=0&id=c34f1614&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c34f1614",
  null
  
)

export default component.exports